export default __webpack_public_path__ + "static/media/2361.57affd2d.png";